import React from 'react';
import Chart from 'react-apexcharts';
import { dayjs } from '../../utils/functions';
export default function BarChartBillBooking({ data }) {
  const state = {
    options: {
      chart: {
        id: 'basic-bar',
      },
      xaxis: {
        categories: _.map(data?.analyzed, (row) =>
          dayjs(row?._id?.month).format('MMM YY'),
        ),
      },
      yaxis: {
        title: {
          text: 'จำนวน BooKing',
        },
      },
      colors: '#06A433',
    },
    series: [
      {
        name: 'จำนวน Booking',
        data: _.map(data?.analyzed, (row) => row?.count),
      },
    ],
  };
  const renderChart = () => (
    <div>
      <Chart
        options={state.options}
        series={state.series}
        type="bar"
        width="500"
      />
    </div>
  );

  return <div>{renderChart()}</div>;
}
